import { defineAsyncComponent, defineComponent, ref } from 'vue';
import { useLoggingStore } from 'src/stores/logging';
import { of } from 'rxjs';
import { tap, filter, switchMap, catchError } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { axiosCallerPlugin } from 'src/plugins/axios/componentAxiosCallerPlugin';
import { parseYTThumbnail as parseYTThumbnailMethod } from 'src/plugins/string/string';
import listingVideo from 'src/features/listing/components/video/videoDialog.vue';
export default defineComponent({
    name: 'share-video',
    components: {
        listingVideo,
        generalDialog: defineAsyncComponent(() => import(
        /* webpackChunkName: "Dialog" */
        'components/general/dialog.vue')),
        lazyLoad: defineAsyncComponent(() => import(
        /* webpackChunkName: "lazyLoad" */
        'components/image/lazyLoad.vue'))
    },
    props: {
        appType: {
            type: String,
            default: 'getspaces'
        },
        listing: {
            type: Object,
            required: true
        },
        receiver: String,
    },
    emits: ['video-sent'],
    setup(props, context) {
        const loggingStore = useLoggingStore();
        const { axiosCall } = axiosCallerPlugin();
        /**
         * Show video list
         */
        const videoRef = ref(null);
        function showVideoListClick() {
            videoRef.value?.showVideoListClick();
        }
        /**
         * Listing share dialog
         */
        const confirmVideoDialog = ref(false);
        const videoConfirmationData = ref(null);
        /**
         * Close video confirmation dialog
         */
        function closeVideoConfirmation() {
            confirmVideoDialog.value = false;
            videoConfirmationData.value = null;
        }
        /**
         * Parse url to youtube embeddable url
         * @param url url string
         */
        function parseYTThumbnail(url) {
            return parseYTThumbnailMethod(url);
        }
        /**
         * open or close dialog
         * @param dialogOpened boolean
         */
        function toggleDialog(dialogOpened) {
            if (dialogOpened)
                return;
            closeVideoConfirmation();
        }
        /**
         * Share video to the guest
         */
        /**
         * Send video to the other party
         * @param data
         */
        function sendVideo(data) {
            videoConfirmationData.value = data;
            confirmVideoDialog.value = true;
        }
        const { subject: sendVideo$ } = rxInitSubjectCallback();
        useObservable(sendVideo$.pipe(switchMap((v) => {
            return of('').pipe(switchMap(() => {
                return axiosCall({
                    type: 'create',
                    state: 'video',
                    urlType: 'chat',
                    url: 'share_video',
                    loading: true,
                    alert: true,
                    message: 'Video Sent',
                    data: {
                        video: v.space_img_url,
                        listing: props.listing.id,
                        share_to: props.receiver
                    }
                });
            }), catchError((err) => {
                loggingStore.errorHandler(err);
                return of({
                    success: false
                });
            }), filter(v => v.success), tap(() => {
                videoRef.value?.hideVideoList();
                closeVideoConfirmation();
                context.emit('video-sent');
            }));
        })));
        return {
            videoRef,
            showVideoListClick,
            confirmVideoDialog,
            videoConfirmationData,
            parseYTThumbnail,
            toggleDialog,
            sendVideo,
            sendVideo$
        };
    }
});
